module.exports = __webpack_public_path__ + "static/media/uoa-23.b9b4a508.jpg";